var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowMessage)?_c('p',{staticClass:"info-message"},[_c('LabelFunMessage',{attrs:{"fcontId":"0","msgkey":"38"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }